export default __webpack_public_path__ + "static/media/success.ccdda0fe.svg";